var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.records),function(record){return _c('div',{key:record.skill,staticClass:"row"},[_c('div',{staticClass:"input-field recordInput"},[_c('span',[_vm._v("Your known "+_vm._s(record.name))]),_vm._v(" "),_c('InputRecord',{attrs:{"record":record,"isReadOnly":false}})],1)])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76aa88d8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/records/InitRecords.vue
// module id = 543
// module chunks = 1